<div class="position custom-padding text-center">
  <div class="card border-{{color}} mb-3" style="max-width: 18rem;">
    <div class="card-header">{{ "LABEL.BAG" | translate }} {{shoppingcard.quantity}}</div>
    <div class="card-body text-{{color}}">
      <h5 class="card-title">{{ "LABEL.BAG-OF" | translate }} {{shoppingcard.quantity}}<small>{{coin}}</small></h5>
      <p class="card-text">{{shoppingcard.description}}</p>
      <h3>{{shoppingcard.quantity}}</h3><small>&nbsp;{{coin}}</small>&nbsp;{{ "LABEL.FOR-ONLY" | translate }}&nbsp;<small>S/.&nbsp;</small>
      <h5>{{shoppingcard.price}}</h5>
    </div>
  </div>
  <div class="text-center">
    <button type="button"
            class="btn btn-outline-{{color}}"
            (click)="openBuyBalanceModal(shoppingcard)">{{ "BUTTON.BUY" | translate }}
    </button>
  </div>
</div>
